<!-- eslint-disable -->
<template lang="pug">
    .invitation
        .invitation__content
            svg-icon.invitation__icon(name="bell", aria-hidden="true", height="50px", width="50px")
            .invitation__request-for-battle {{ requestForBattleText }}
            .invitation__text(v-html="$i18n.t('battle.battle_are_you_ready')")
            .invitation__buttons
                cs-button.button.button__yes(:disabled="isAcceptButtonDisabled" @click="acceptInvite") {{ $i18n.t('battle.battle_yes') }}
                cs-button.button.button__no(@click="declineInvite") {{ $i18n.t('battle.battle_no') }}
</template>

<script>
    /*eslint-disable*/
    import { mapState } from 'vuex';
    import BattleApi from "../../api/battle";

    const TIME_FOR_REPLY = 30000;

    export default {
        data() {
            return {
                battleParameters: null,
            };
        },
        created () {
            window.addEventListener('beforeunload', this.beforeTabClosed);
        },
        beforeDestroy () {
            window.removeEventListener('beforeunload', this.beforeTabClosed);
        },
        mounted() {
            BattleApi.show(this.invitation.battleId).then((data) => {
                this.battleParameters = data;
            })
        },
        methods: {
            declineInvite () {
                if (this.invitation) {
                    BattleApi.cancelInvite({declineFrom: 'opponent'})
                        .then(() => {
                            this.$store.dispatch('setBattleInvitation', null);
                        }).catch(err => {
                            this.$store.dispatch('setBattleInvitation', null);
                            if (err && err.data && err.data.message) {
                                this.$toasted.error(this.$i18n.t(`errors.${err.data.message}`));
                            } else {
                                this.$toasted.error(this.$i18n.t(`errors.error_has_occurred`));
                            }
                    });
                }
            },
            beforeTabClosed () {
                this.declineInvite();
                return null;
            },
            acceptInvite () {
                if (this.invitation) {
                    BattleApi.acceptInvite({'battleId': this.invitation.battleId}).then(() => {
                        if (!this.isInvitationDeclined) {
                            this.$router.push({name: 'battle:start', params: {id: this.invitation.battleId, opponent: this.invitation.opponent}});
                        }
                        this.$store.dispatch('setBattleInvitation', null);
                    }).catch(err => {
                        this.$store.dispatch('setBattleInvitation', null);
                        if (err && err.data && err.data.message) {
                            this.$toasted.error(this.$i18n.t(`errors.${err.data.message}`));
                        } else {
                            this.$toasted.error(this.$i18n.t(`errors.error_has_occurred`));
                        }
                    });
                }
            }
        },
        computed: {
            ...mapState({
                invitation: state => state.battle.invitation,
                isInvitationDeclined: state => state.battle.isInvitationDeclined,
            }),
            isAcceptButtonDisabled() {
                let currentWidth = window.innerWidth;
                return (
                    this.battleParameters &&
                    currentWidth < 768 &&
                    !!this.battleParameters.levels.find(level => {
                        return level.stages.find(stage => {
                            return stage.games.find(game => {
                                return game.slug === 'Navigator' && game.parameters.default.difficult > 7;
                            });
                        });
                    })
                );
            },
            requestForBattleText () {
                return this.invitation.opponent.fullName + " (" + this.invitation.opponent.city + ") "
                    + this.$i18n.t('battle.battle_invites_you', {
                        type: this.invitation.isTraining ? this.$i18n.t('battle.battle_invitation_training') : ''
                    });
            }
        }
    }
</script>

<style scoped lang="scss">
    .invitation {
        height: 100%;
        width: 100%;
        position: absolute;
        pointer-events: none;
    }
    .invitation__content {
        background: #FFFFFF;
        position: fixed;
        bottom: 30px;
        right: 30px;

        z-index: 3;
        box-shadow: 0 0 40px rgba(51, 51, 51, 0.4);
        border-radius: 40px;

        pointer-events: all;
        padding: 30px;
        text-align: center;

        width: 205px;

        @include media($sm) {
            width: auto;
            min-width: 320px;
            max-width: 370px;
        }
    }
    .invitation__bell {
        margin: 0 auto;
        @media screen and (max-width: 575px) {
            display: none;
        }
    }
    .invitation__icon {
        display: none;
        @include media($sm) {
            display: inline-flex;
        }
    }
    .invitation__request-for-battle {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        color: #333333;
        @include media($sm) {
            margin-top: 15px;
        }
    }
    .invitation__text {
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: #333333;
        margin: 10px 0;
    }
    .button {
        height: auto;
        padding: 15px 30px;
        border-radius: 40px;
        color: #FFFFFF;
        border: 0;
    }
    .button__yes {
        background: #6BBD6C;
        margin-right: 16px;
    }
    .button__no {
        background: #FF7245;
        &:hover {
            background: #F55A29;
        }
    }
</style>
